import React from 'react';
// import api from '../axiosConfig';
import '../css/leaderboard.css';
import trophy from '../assets/Trophy_icon.png';
import Group from '../utils/Group';

const Leaderboard = ({ leaderboardData, showWinner, styles, customStylesClass }) => {
  if (!leaderboardData) {
    return null;
  }

  const unbranded = customStylesClass && customStylesClass.includes('unbranded');

  return (
    <div className="leaderboard-container">
      {/* Column Containers */}
      <div className="leaderboard-column-container">
        {/* Region Column */}
        <div className="leaderboard-column">
          <div className="leaderboard-header-cell" style={styles}>
            Region
          </div>
          {leaderboardData.map((group) => (
            <div
              key={group.id}
              className={`leaderboard-cell leaderboard-region-cell leaderboard-region-${group.groupIndex} ${
                customStylesClass ? customStylesClass : ''
              }`}
            >
              {group.groupName}
            </div>
          ))}
        </div>

        {/* Points Column */}
        <div className="leaderboard-column">
          <div className="leaderboard-header-cell" style={styles}>
            Points
          </div>
          {leaderboardData.map((group) => (
            <div
              key={group.id}
              className={`leaderboard-cell leaderboard-points-cell leaderboard-region-${group.groupIndex} ${
                customStylesClass ? customStylesClass : ''
              }`}
            >
              <div className="leaderboard-center-content">
                <Group group={group} />
              </div>
            </div>
          ))}
        </div>

        {/* Winner Column */}
        <div className="leaderboard-column">
          <div className="leaderboard-header-cell" style={styles}>
            Winner
          </div>
          {leaderboardData.map((group) => (
            <div
              key={group.id}
              className={`leaderboard-cell leaderboard-winner-cell ${
                group.isWinner && showWinner && !unbranded ? 'winner' : ''
              }`}
            >
              <div className="leaderboard-winner-icon">
                {group.isWinner && showWinner ? <img src={trophy} alt="trophy" /> : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
